module.exports = __webpack_public_path__ + "static/media/equipment_04.a3058fd7.jpg";